import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadViolationByIdFailed, loadViolationByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { applyViolationImagesResponse, IMAGE_STORAGE_UNAVAILABLE_MESSAGE } from '../violationImages';

export default function* loadViolationById(action) {
  try {
    const url = `${BACKEND_URL}/violations/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      try {
        const imagesResp = yield makeRequest(`${BACKEND_URL}/violations/${action.payload}/images`, {}, action, 'GET', true);
        const imagesBody = yield imagesResp.json();
        data.data = applyViolationImagesResponse(data.data, imagesResp.status, imagesBody);
      } catch (e) {
        data.data = applyViolationImagesResponse(data.data, 0, {
          message: IMAGE_STORAGE_UNAVAILABLE_MESSAGE,
        });
      }

      yield put(loadViolationByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadViolationByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadViolationByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
